import { useCallback } from 'react';

import { useSetState } from './use-set-state.js';
import type { Point } from '../../../core/types/point.js';
import type { InternalTooltipContent } from '../../types/internal/pie-chart.js';

export const useSetTooltipState = () => {
  const setState = useSetState();

  const setTooltipStateContent = useCallback(
    (content: InternalTooltipContent | undefined) => {
      setState((prev) => {
        return {
          ...prev,
          tooltip: {
            ...prev.tooltip,
            content,
          },
        };
      });
    },
    [setState],
  );

  const setTooltipStatePosition = useCallback(
    (position: Point) => {
      setState((prev) => {
        return {
          ...prev,
          tooltip: {
            ...prev.tooltip,
            position,
          },
        };
      });
    },
    [setState],
  );

  const setTooltipStateVisibility = useCallback(
    (visible: boolean) => {
      setState((prev) => {
        return {
          ...prev,
          tooltip: {
            ...prev.tooltip,
            visible,
          },
        };
      });
    },
    [setState],
  );

  const setTooltipStatePinned = useCallback(
    (pinned: boolean) => {
      setState((prev) => {
        return {
          ...prev,
          tooltip: {
            ...prev.tooltip,
            pinned,
          },
        };
      });
    },
    [setState],
  );

  return {
    setTooltipStateContent,
    setTooltipStatePosition,
    setTooltipStateVisibility,
    setTooltipStatePinned,
  };
};
